/**
 * Calls the backend Supabase function to process a pending invitation.
 * @param {string} token - The invitation token.
 * @param {string} userAccessToken - The access token of the authenticated user.
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export async function processInvitationAPI(token, userAccessToken) {
  console.log('[invitationUtils.js] Calling /functions/v1/process-invitation with token:', token);
  try {
    const response = await fetch('/functions/v1/process-invitation', { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userAccessToken}`,
        'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTc0NzEyNjU3NSwiZXhwIjoyMDYyNDg2NTc1LCJpc3MiOiJzdXBhYmFzZSJ9.oIo6GvVIQ0CjeO9vBepnZUNvB9RqzYbQXlE8nIJWVOg'
      },
      body: JSON.stringify({ invitation_token: token })
    });

    const responseBody = await response.json(); 
    if (!response.ok) {
      console.error('[invitationUtils.js] Backend /process-invitation error:', responseBody);
      // Prefer details if available, then error, then a generic message
      const message = responseBody.details || responseBody.error || responseBody.message || 'Failed to process invitation via backend.';
      throw new Error(message);
    }
    console.log('[invitationUtils.js] Backend /process-invitation success:', responseBody);
    return { success: true, data: responseBody };
  } catch (error) {
    console.error('[invitationUtils.js] Exception calling /process-invitation:', error);
    return { success: false, error: error.message || 'Network error or failed to parse response.' };
  }
} 